export default __webpack_public_path__ + "static/media/E20.a64e6892.jpg";